import { Hotel } from "./hotel";

export class CountryGroup{
  country_code:string;
  customers:Hotel[] = [];
  constructor(country_code){
    this.country_code = country_code;
  }
}
